export default {
  funds: {
    title: 'Buscar Valor Cuota',
    subtitle: 'Selecciona entre Fondos mutuos o inversión y luego selecciona el fondo y la fecha.',
    selectFund: 'Seleccione un fondo',
    selectDate: 'Seleccione fecha',
    date: 'Fecha',
    fund: 'Fondo',
    search: 'Buscar',
    table: {
      date: 'Fecha',
      value: 'Valor',
      equity: 'Patrimonio',
      shares: 'Cuota de Circulación',
    },
    empty: {
      title: 'Datos en preparación',
      description:
        'Los datos para el periodo consultado se encuentran en etapa de preparación.',
    },
  },
};
